import { Select, SelectProps, styled } from '@mui/material'

type MolsonSelectProps = SelectProps & {
  dataTestId?: string
}

const StyledSelect = styled(Select)({
  '& > div:first-of-type': {
    height: 49,
    display: 'flex',
    alignItems: 'center'
  }
})

export const MolsonSelect = ({
  dataTestId,
  children,
  ...props
}: MolsonSelectProps) => {
  return (
    <StyledSelect variant="outlined" data-testid={dataTestId} {...props}>
      {children}
    </StyledSelect>
  )
}
